import React from 'react';
import { appHasEditor, newAppHasEditor, getAppDashboardDataNew, getAppPages, getAppWidgets, getEditorPlatformComps, isPremiumFromBundle, isMLApp, } from '../../../utils/appUtils';
import { EditorType, Origin } from '../../manage-installed-apps-page';
import { useExperiments } from '@wix/wix-experiments-react';
import { DeleteDashboardModal } from './delete-dashboard-modal';
import { DeleteWidgetAppModal } from './delete-widget-modal';
import { DeleteHybridAppModal } from './delete-hybrid-modal';
import { DeletePageAppModal } from './delete-page-modal';
import { DeletePremiumModal } from './delete-premium-modal';
import { DeleteEditorModalFromBM } from './delete-editor-modal-from-BM';
import { RenewalType as RenewalTypeNew } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import { PaymentCollectionType } from '@wix/ambassador-premium-v1-asset/types';
export function DeleteModal({ app, msId, origin, editorUrl, deleteApp, closeModal, editorType, baseUrl, authorizationHeader, openDeleteModalAppInEditor, isEditorless, }) {
    const { experiments } = useExperiments();
    const activePremiumNew = app?.premiumInfo?.isUpgraded &&
        app?.premiumInfo?.renewalType !== RenewalTypeNew.AUTO_RENEW_OFF;
    const appNameFromData = app?.appInfo?.name;
    const appName = appNameFromData?.replace('&amp;', '&');
    const appId = app?.appId;
    const activePremium = activePremiumNew;
    const isOneTimePlan = app?.premiumInfo?.paymentCollectionType === PaymentCollectionType.ONE_TIME;
    const shouldShowPremiumModal = activePremium && !isPremiumFromBundle(app) && !isOneTimePlan;
    if (shouldShowPremiumModal) {
        return (React.createElement(DeletePremiumModal, { appId: appId, appName: appName, handleClose: closeModal, msId: msId }));
    }
    const isAppWithEditorComponents = experiments.enabled('specs.app-market.BlocksUninstallFix')
        ? newAppHasEditor(app)
        : appHasEditor(app);
    if (origin === Origin.BIZMGR && (isMLApp(appId) ||
        (editorType !== EditorType.ADI && isAppWithEditorComponents)) && !isEditorless) {
        return (React.createElement(DeleteEditorModalFromBM, { appId: appId, appName: appName, handleClose: closeModal, openDeleteModalAppInEditor: openDeleteModalAppInEditor, msid: msId }));
    }
    if (!isAppWithEditorComponents ||
        (editorType !== EditorType.ADI &&
            origin === Origin.EDITOR) ||
        isMLApp(appId) ||
        isEditorless) {
        return (React.createElement(DeleteDashboardModal, { app: app, msId: msId, origin: origin, handleClose: closeModal, handleDeleteApp: deleteApp, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, showNotification: !isAppWithEditorComponents && !isMLApp(appId) }));
    }
    if (getAppPages(app).length) {
        return (React.createElement(DeletePageAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    if (getAppWidgets(app).length || getEditorPlatformComps(app).length) {
        return (React.createElement(DeleteWidgetAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    if (isAppWithEditorComponents &&
        getAppDashboardDataNew(app)) {
        return (React.createElement(DeleteHybridAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    else {
        return (React.createElement(DeleteWidgetAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
}
//# sourceMappingURL=delete-modal.js.map